import { useNavigate } from "react-router";
import "./CustomOrders.css";

export default function CustomOrders() {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/contact");
    }

    return (
        <section className="customOrders">
            <div className="outer">
                <div className="left">
                    <p id="tag">CUSTOM PRINTS AVAILABLE</p>
                    <h2>Have Your Own STL Files?</h2>
                    <p>
                        Work directly with Quaking Aspen 3D Printing to bring your ideas into reality. Whether it's a personalized design you'd like to see on your own dice vault or tower, or an epic miniature for your favorite character, you bring the design and we'll bring our printing expertise.
                    </p>
                    <button onClick={handleClick}>Contact Us for a Quote</button>
                </div>
                <div className="right">
                    <div className="custom-feature">
                        <h3>Fast Production</h3>
                        <p>High-detailed printing options available.</p>
                    </div>
                    <div className="custom-feature">
                        <h3>Fantasy Focused</h3>
                        <p>Designed for tabletop gamers, collectors, and creators.</p>
                    </div>
                    <div className="custom-feature">
                        <h3>Built to Impress</h3>
                        <p>Display-worthy pieces crafted with attention to detail.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}